/**
 * @description remove heading and tailing '/'
 * @example
 * removeBoundingSlashes('a') => 'a'
 * removeBoundingSlashes('/a/') => 'a'
 * removeBoundingSlashes('a/') => 'a'
 * removeBoundingSlashes('/a') => 'a'
 */
function removeBoundingSlashes(path: string) {
  // remove tailing '/'
  const res = path.endsWith("/") ? path.slice(0, -1) : path;

  // remove heading '/'
  return res.startsWith("/") ? res.slice(1) : res;
}

/**
 * @description concat path(s) to base, with heading '/' and without tailing '/'
 * @example
 * safeJoinPath('a/b/c','d','e/','','/') => '/a/b/c/d/e'
 * safeJoinPath('https://cdn.payping.ir/', '/statics/img.png') => 'https://statics.payping.ir/img.png'
 */
export function safeJoinPath(base: string, ...paths: string[]): string {
  const safePaths = paths.map((path) => {
    // remove all tailing '/' and add heading '/'
    const safePath = removeBoundingSlashes(path);

    // skip empty paths (evaluate as null)
    return safePath !== "" ? `/${safePath}` : null;
  });
  const noSlashBase = removeBoundingSlashes(base);
  // eslint-disable-next-line no-nested-ternary
  const safeBase = /^https?/gi.test(noSlashBase) ? noSlashBase : noSlashBase !== "" ? `/${noSlashBase}` : "";

  // concat array of paths to base
  return `${safeBase}${safePaths.join("")}`;
}

/**
 * @description remove path from base with perpetual heading "/" and remove tailing '/'
 *@example
 * safeDeletePath('a/b/c/d','d') => '/a/b/c'
 */
export function safeDeletePath(base: string, path: string): string {
  // start matching from end of string for common string until first '/'
  const expression = new RegExp(`((\\/|^)${removeBoundingSlashes(path)})?(\\/?)$`, "gi");

  // remove matched substring from base
  const cleanedPath = removeBoundingSlashes(base).replace(expression, "");

  // add heading '/'
  return `/${cleanedPath}`;
}
